var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
        'TRC-Page': 1,
        'TRC-Page--rounded': _vm.rounded,
    }},[_c('div',{class:{
            'TRC-Page__Frame': 1,
            'TRC-Page__Frame--Border': !_vm.requiresBorder
        }},[_c('div',{staticClass:"TRC-Page__ContentContainer"},[(_vm.requiresNavigation)?_c('div',{staticClass:"TRC-Page__Nagivation"},[_c('app-navbar')],1):_vm._e(),_vm._v(" "),(_vm.requiresHeader)?_c('div',{staticClass:"TRC-Page__Hero"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),(_vm.requiresBanner)?_c('div',{staticClass:"TRC-Page__Banner"},[_vm._t("banner")],2):_vm._e(),_vm._v(" "),(_vm.requiresAccordion)?_c('div',{staticClass:"TRC-Page__Accordion"},[_vm._t("accordion")],2):_vm._e(),_vm._v(" "),_c('div',{class:{
                    'TRC-Page__Content': 1,
                    'TRC-Page__Content--short': _vm.shorten,
            }},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }